module.exports = __webpack_public_path__ + "img/034-tibet.3d868379.svg";